import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { uploadMedia } from "@/lib/api";

/** Invokes file picker, uploads via /api/media, calls onUploaded({ id, url, ext, mime, size, original_name }). */
export default function MediaUploadButton({ onUploaded, multiple = true, children, testid = "media-upload-btn" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const onPick = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    for (const f of files) {
      if (!f.type.startsWith("image/")) { toast.error(`${f.name} is not an image`); continue; }
      try {
        const res = await uploadMedia(f);
        onUploaded?.(res);
      } catch {
        toast.error(`Upload failed: ${f.name}`);
      }
    }
    setBusy(false);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => ref.current?.click()}
        disabled={busy}
        data-testid={testid}
        className="inline-flex items-center gap-2 h-10 px-4 rounded-md border border-zinc-300 bg-white hover:bg-zinc-50 text-sm font-medium disabled:opacity-50"
      >
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
        {children || (busy ? "Uploading…" : "Upload images")}
      </button>
      <input
        ref={ref}
        type="file"
        accept="image/*"
        multiple={multiple}
        className="hidden"
        onChange={onPick}
      />
    </>
  );
}
